import { Alert, Button, ComboboxData, ComboboxItem, Group, Modal, Select, Stack } from "@mantine/core";
import React, { useMemo, useState } from "react";
import { useGetProjectByProjectIdIssuesOnBoardQuery, usePutIssueConnectMutation } from "../../../openapi";
// import { useDoGetAllIssuesQuery } from "../../app/routes/issuesApp/issueRTK";

export const ConnectIssueModal: React.FC<{
  projectId: string;
  boardId: string;
  sourceIssueId: string;
  opened: boolean;
  onClose: () => void;
}> = ({ projectId, boardId, sourceIssueId, opened, onClose }) => {
  return (
    <Modal opened={opened} onClose={onClose} zIndex={1300} size="md" title="Koble sak til">
      <ConnectIssueModalContent
        projectId={projectId}
        boardId={boardId}
        sourceIssueId={sourceIssueId}
        opened={opened}
        onClose={onClose}
      />
    </Modal>
  );
};

const ConnectIssueModalContent: React.FC<{
  projectId: string;
  boardId: string;
  sourceIssueId: string;
  opened: boolean;
  onClose: () => void;
}> = ({ projectId, boardId, sourceIssueId, opened, onClose }) => {
  const [selectedIssue, setSelectedIssue] = useState<ComboboxItem | null>(null);

  const {
    data: issuesOnBoard,
    error: errorIssues,
    isFetching: isIssuesFetching,
  } = useGetProjectByProjectIdIssuesOnBoardQuery(
    {
      projectId,
      issueboardId: boardId,
    },
    { skip: boardId == null },
  );

  const [connectIssues, { isLoading: connectLoading }] = usePutIssueConnectMutation();

  const issueSelectData: ComboboxData = useMemo(
    () =>
      (issuesOnBoard ?? [])
        .map((issue) => ({
          value: issue._id,
          label: `${issue.id}: ${issue.title}`,
        }))
        .filter((item) => item.value !== sourceIssueId),
    [issuesOnBoard],
  );

  return (
    <Stack gap={"sm"}>
      {errorIssues != null && <Alert color="red">En feil oppsto ved henting av saker.</Alert>}
      <Select
        comboboxProps={{ withinPortal: true, zIndex: 2000 }} // keep dropdown above Modal
        disabled={
          isIssuesFetching === true ||
          (issuesOnBoard?.length ?? 0) < 1 ||
          connectLoading === true ||
          errorIssues != null
        }
        placeholder={"Velg sak"}
        searchable
        data={issueSelectData}
        value={selectedIssue?.value}
        onChange={(val) => setSelectedIssue(val ? { value: val, label: val } : null)}
        nothingFoundMessage="Ingen saker"
      />
      <Group justify="space-between">
        <Button onClick={() => onClose()} variant="outline" disabled={connectLoading === true}>
          Lukk
        </Button>
        <Button
          variant="filled"
          disabled={selectedIssue == null || connectLoading === true}
          loading={connectLoading === true}
          onClick={async () => {
            if (selectedIssue != null) {
              await connectIssues({
                body: {
                  projectId: projectId,
                  issueBoardId: boardId,
                  sourceIssueId: sourceIssueId,
                  targetIssueId: selectedIssue.value,
                  action: "CONNECT",
                },
              });

              setSelectedIssue(null);
              onClose();
            }
          }}
        >
          Koble sak
        </Button>
      </Group>
    </Stack>
  );
};
